// Search here. https://remixicon.com/

export const icons = {
    "utl-ai-logging": "ri-list-settings-line",
    "utl-generate": "ri-refresh-line",
    "utl-copy": "ri-clipboard-line",
    "utl-logging": "ri-bug-2-line",
    "utl-token": "ri-shield-line",
    "utl-translations": "ri-text-snippet",
    "utl-settings": "ri-settings-4-line",
    "utl-audit": "ri-shield-check-line",
    "utl-notice": "ri-sticky-note-line",
    "utl-defects": "ri-bug-line",
    "utl-stats": "ri-bar-chart-2-line",
    "utl-message-templates": "ri-mail-line",
    "utl-external-links": "ri-external-link-line"
};
